import { render, staticRenderFns } from "./kpiTable.vue?vue&type=template&id=843ce038&scoped=true&"
import script from "./kpiTable.vue?vue&type=script&lang=js&"
export * from "./kpiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843ce038",
  null
  
)

export default component.exports